import { Link } from "react-router-dom";
import "./Header.css"

let Header=()=>{
    let checkinnerhtml=(e)=>{
        let linkss =document.querySelectorAll('.header_links');
        for(let i=0; i<=linkss.length-1; i++){
            linkss[i].style.cssText = "color : black;"
        }
    for(let i=0; i<=linkss.length-1; i++){
        if(e.target.innerHTML === linkss[i].innerHTML){
            linkss[i].style.cssText = "color: red;"
        }
    }
    }
    

    return(
        <div className="headermain_cont"> 
            
            <Link onClick={checkinnerhtml} className="header_links" to='./'>Home</Link>
            <Link onClick={checkinnerhtml} className="header_links" to='./LatestJobs' >Latest Jobs</Link>
            <Link onClick={checkinnerhtml} className="header_links" to='./Admitcard' >Admit Card</Link>
            <Link onClick={checkinnerhtml} className="header_links" to='./Results' >Result</Link>
            {/* <Link onClick={checkinnerhtml} className="header_links" >Contact Us</Link>
            <Link onClick={checkinnerhtml} className="header_links" >About Us</Link> */}
        </div>
    );
} 
 export default Header;

